import { ReactNode } from 'react';
import { QuestionMarkIconTooltip } from '../../icons/truWeb-icons';
import './style.scss';

type Props = {
  children: ReactNode;
  title: string;
  classes?: string;
  position?:
  | 'top right'
  | 'top center'
  | 'top left'
  | 'bottom right'
  | 'bottom center'
  | 'bottom left'
  | 'left top'
  | 'left center'
  | 'left bottom'
  | 'right top'
  | 'right center'
  | 'right bottom';
};

export const Tooltip = ({
  children,
  title,
  classes,
  position = 'bottom left',
}: Props) => {
  const startPoint = position.split(' ');
  return (
    <div
      data-title={title}
      className={`tooltip-container x-${startPoint[0]} y-${startPoint[1]} ${classes}`}
    >
      {children}
    </div>
  );
};



export const MoreInfoTooltipDynamicForms = ({
  moreInfo,
}: any) => {
  return (
    <>
      <span className="more-info-tooltip">
        <Tooltip title={moreInfo} position="top center">
          <QuestionMarkIconTooltip />
        </Tooltip>
      </span>
    </>
  );
};
